export default __webpack_public_path__ + "static/media/recordFile.5faaca74.svg";